<template>
    <v-app class="main-dashboard">
        <v-navigation-drawer
            v-model="drawer"
            app
            dark
            :permanent="($vuetify.breakpoint.xlAndUp) ? true : false"
            style="background-color: #3C3C3C;"
        >

            <!-- main list -->
            <v-list class="pt-0" dense v-if="showDrawer">
                <v-img
                    :src="banner.includes('bg-store') ? '' : banner"
                    height="120px"
                    class="align-end bg-red"
                    gradient="to bottom, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                >
                    <v-list>
                        <v-list-item>
                            <v-img
                                :src="logo"
                                alt="admin"
                                height="auto"
                                max-width="85px"
                                class="mr-2 rounded-lg"
                                v-if="!logo.includes('logo-default')"
                            />
                            <v-list-item-content>
                                <v-list-item-title>{{ userName }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-img>

                <div id="switch-container" style="padding: 5px; ">
                    <div id="switch-app"></div>
                </div>

                <sales-expenses
                    :slug="slug"
                    :money="money"
                    :btn-sale="showBtnNewSales"
                    :btn-expense="showBtnNewExpense"
                    :type-store="typeStore"
                    :has-quotes="hasQuotes"
                    v-if="physicalStore"
                />

                <!-- <div class="px-3 mb-4" v-if="physicalRestaurant">
                    <v-btn
                        color="primary"
                        dark
                        class="capitalize"
                        small
                        block
                        :href="physicalRestaurantUrl"
                        target="_blank"
                    >Restaurante fīsico</v-btn>
                </div> -->

                <!-- main menu -->
                <template v-for="(item, index) in items">

                    <!-- <v-list-item :key="index" v-if="item.header">
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item> -->

                    <template v-if="item.role==userRole || item.role==''">
                        <v-list-item
                            :key="index"
                            link
                            :href="item.path"
                            :target="item.title=='Diseño' ? '_blank' : ''"
                            :class="[(path == item.path) ? 'active' : '']"
                            v-if="!item.header && !item.subItems && item.show"
                        >
                            <v-list-item-icon>
                                <v-icon :color="(path == item.path)?'primary':''">mdi-{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title :class="(path == item.path)?'primary--text':''">
                                {{ item.title }}
                            </v-list-item-title>
                            <v-list-item-action v-if="item.title==$t('Ventas Digitales')">
                                <v-badge
                                    inline
                                    :value="cantOrder"
                                    :content="cantOrder"
                                    color="error"
                                ></v-badge>
                            </v-list-item-action>
                            <v-list-item-action v-if="item.title==$t('Pedidos, puntos de venta')">
                                <v-badge
                                    inline
                                    :value="cantOrder2"
                                    :content="cantOrder2"
                                    color="error"
                                ></v-badge>
                            </v-list-item-action>
                            <v-list-item-action v-if="item.title==$t('Preventas')">
                                <v-badge
                                    inline
                                    :value="cantOrder3"
                                    :content="cantOrder3"
                                    color="error"
                                ></v-badge>
                            </v-list-item-action>
                            <v-list-item-action v-if="item.title==$t('Agendamiento')">
                                <v-badge
                                    inline
                                    :value="cantOrder4"
                                    :content="cantOrder4"
                                    color="error"
                                ></v-badge>
                            </v-list-item-action>
                        </v-list-item>
                    </template>

                    <template v-if="item.role==userRole || item.role==''">
                        <v-list-group
                            :key="index"
                            v-model="item.active"
                            :prepend-icon="`mdi-${item.icon}`"
                            no-action
                            v-if="!item.header && item.subItems && item.show"
                            color="white"
                        >
                            <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.title }}
                                    <v-badge
                                            inline
                                            :value="cantOrder"
                                            :content="cantOrder"
                                            color="error"
                                            class="mt-0"
                                            v-if="item.title==$t('Ventas')"
                                        ></v-badge>
                                </v-list-item-title>
                            </v-list-item-content>
                            </template>

                            <v-list-item
                                v-for="child in item.subItems"
                                :key="child.title"
                                link
                                :href="child.path"
                                :class="[(path == child.path) ? 'active' : '']"
                                :disabled="child.disabled"
                                v-if="child.show"
                            >
                                <v-list-item-content>
                                    <v-list-item-title class="d-flex align-center justify-space-between" :class="(path == child.path)?'primary--text':''">
                                        {{ child.title }}
                                        <v-badge
                                            inline
                                            :value="cantOrder"
                                            :content="cantOrder"
                                            color="error"
                                            class="mt-0"
                                            v-if="child.title==$t('Ventas Digitales')"
                                        ></v-badge>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-group>
                    </template>

                </template>
                <!-- end main menu -->

            </v-list>
            <!-- end main list -->

            <v-list v-else>
                <v-list-item>
                    <v-list-item-content>
                        <v-skeleton-loader
                        class="mx-auto"
                        type="card, text, text, text"
                        ></v-skeleton-loader>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <div class="pa-5 white--text text-center logo-menu">
                Potenciado por
                <v-img
                    src="/images/quick2.png"
                    width="100%"
                    max-width="150px"
                    class="mx-auto mt-2"
                ></v-img>
            </div>

        </v-navigation-drawer>

        <!-- main appbar -->
        <v-app-bar
            app
        >
            <!-- btn drawer -->
            <v-app-bar-nav-icon color="primary" @click.stop="drawer = !drawer" v-show="!$vuetify.breakpoint.lgAndUp"></v-app-bar-nav-icon>

            <!-- <v-spacer> -->
            <a href="#"
                title="Ayuda" target="_blank" class="btn btn-sm py-0 pt-0 d-block" style="font-size: 1.5em;"
                @click.prevent="showTutoriales"
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width=25 height=25 >
                    <path fill="white" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3" />
                    <path fill="red" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                </svg>
            </a>
            <v-menu offset-y v-if="userRole=='store' && branches.length>0">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="ml-4"
                        outlined
                    >
                        {{ branches.filter(b=>b.slug==slug)[0].name_store }}
                        <v-icon>mdi-menu-down</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                        v-for="child in branches"
                        :key="child.name_store"
                        :disabled="child.slug==slug"
                        @click.prevent="changeBranch(child.slug)"
                    >
                        <v-list-item-title :class="{'current--text':child.type_store=='main'}">{{ child.name_store }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-spacer/>

            <!-- my site -->
            <v-btn
                color="error"
                outlined
                class="mr-3"
                v-if="typeCash=='open' && !btnCloseCash && !['admin','editor'].includes(userRole)"
                @click="dialogCash=true, typeCash='close'"
            >{{ $t('Cerrar caja') }}</v-btn>
            <v-btn
                target="_blank"
                :href="`/${slug}`"
                color="primary"
                class="mr-3"
                v-if="slug!=''"
            >{{ $t('Ir a mi sitio') }}</v-btn>
            <!-- my site end -->

            <!-- menu account -->
            <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="mr-0"
                    >
                        <v-icon>mdi-account-circle</v-icon>
                    </v-btn>
                </template>
                <v-list dense min-width="250px">
                    <v-list-item>
                        <v-list-item-avatar>
                            <img
                                src="/images/user-default.png"
                                alt="admin"
                                style="object-fit:cover; object-position:center;"
                            >
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ userName }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :href="`${userRole=='admin' ? '/admin/my-account' : '/admin/my-store'}`">
                        <v-list-item-icon>
                            <v-icon>mdi-account-edit</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('Mi cuenta') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item href="/logout" @click.prevent="logout">
                        <v-list-item-icon>
                            <v-icon>mdi-logout</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('Cerrar sesión') }}</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item v-if="userRole!=='admin'" :class="(ifEmergency)?'success':'error'" dark @click="changeEmergency">
                        <v-list-item-icon>
                            <v-icon>mdi-exit-run</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ (ifEmergency) ? $t('Abrir tienda') : $t('Cerrar por emergencia') }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <!-- end menu account -->

        </v-app-bar>
        <!-- end main appbar -->

        <v-main class="grey lighten-3">
            <slot/>

            <!-- boton whatsapp -->
            <v-fab-transition>
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            large
                            dark
                            fixed
                            bottom
                            right
                            v-bind="attrs"
                            v-on="on"
                            color="#28ac00"
                            :href="`https://wa.me/59169422693?text=Hola%20Necesito%20ayuda%20con%20la%20tienda%20${slug}.`"
                            target="_blank"
                        >
                            <v-icon>mdi-whatsapp</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t('¿Necesitas ayuda?') }}</span>
                </v-tooltip>
            </v-fab-transition>
            <!-- end boton whatsapp -->
        </v-main>

        <!-- <v-footer
            app
            inset
        >
            <span>Quick Restaurantes &copy; {{ new Date().getFullYear() }}</span>
        </v-footer> -->

        <!-- dialog cash -->
        <v-dialog
            v-model="dialogCash"
            persistent
            max-width="350"
        >
            <open-cash :type-cash="typeCash" @close-modal="dialogCash=false" :money="money"></open-cash>
        </v-dialog>
        <!-- END dialog cash -->

        <!-- Diálogo de venta completada -->
        <v-dialog
            v-model="dialogSale"
            max-width="450"
            persistent
            transition="dialog-bottom-transition"
        >
            <v-card class="text-center pa-2">
                <!-- Icono de éxito -->
                <div class="pa-4 d-flex justify-center">
                    <v-avatar color="success" size="64">
                        <v-icon size="40" dark>mdi-check-circle</v-icon>
                    </v-avatar>
                </div>
                <v-card-text class="pt-6 pb-2">
                    <v-alert type="success" dense border="left" colored-border>
                        {{ $t('Se ha registrado una nueva venta digital con éxito') }}
                    </v-alert>
                </v-card-text>

                <!-- Acciones -->
                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="error"
                        @click="dialogSale = false"
                        depressed            >
                        {{ $t('Cerrar') }}
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="px-6"
                        @click="goToDigitalSales"
                        depressed
                    >
                        {{ $t('Ir a Ventas Digitales') }}
                        <v-icon right>mdi-arrow-right</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity="1" z-index="10" color="grey lighten-3">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
    </v-app>
</template>
<style>
    .dd-option-text, .dd-selected-text {
        color: black !important;
    }
</style>
<script>

export default {
    data() {
        return {
            overlay: false,
            drawer: null,
            path: '/',
            items: [],
            ifEmergency: false,
            dialogSale: false,
            // notifications
            cantOrder: 0,
            cantOrder2: 0,
            cantOrder3: 0,
            cantOrder4: 0,
            // banner y logo
            banner: '',
            logo: '',
            showDrawer: false,
            // tienda fisica
            physicalStore: false,
            showBtnNewSales: false,
            showBtnNewExpense: false,
            hasQuotes: false,
            // restaurabte fisico
            physicalRestaurant: false,
            physicalRestaurantUrl: '',
            // cash
            dialogCash: false,
            btnCloseCash: false,
            typeCash: 'open',
            // sucursales
            branches: [],
        }
    },
    props: [
        'userId',
        'userName',
        'userRole',
        'slug',
        'money',
        'userEmail',
        'typeStore'
    ],
    created() {
        this.items = [
            {
                header: true,
                role: '',
                title: ''
            },
            // admin
            {
                header: false,
                role: 'admin',
                icon: 'view-dashboard',
                title: this.$t('Mi panel'),
                path: '/admin/dashboard',
                show: true
            },
            {
                header: false,
                role: 'admin',
                icon: 'store',
                title: this.$t('Negocios'),
                subItems: [
                    { title: this.$t('Nuevo registro'), path: '/admin/new-store', disabled: false, show:true },
                    { title: this.$t('Listar negocios'), path: '/admin/stores', disabled: false, show:true },
                ],
                show: true
            },
            {
                header: false,
                role: 'admin',
                icon: 'domain',
                title: this.$t('Tiendas matriz'),
                subItems: [
                    { title: this.$t('Nuevo registro'), path: '/admin/new-parent-store', disabled: false, show:true },
                    { title: this.$t('Listar Tiendas'), path: '/admin/parent-stores', disabled: false, show:true },
                ],
                show: true
            },
            // store
            {
                header: false,
                role: 'store',
                icon: 'cart',
                title: this.$t('Ventas'),
                show: false,
                subItems: [
                    { title: this.$t('Ventas Digitales'), path: '/admin/orders', disabled: false, show: false, permission: 'view_orders' },
                    { title: this.$t('Ventas Fisicas'), path: '/admin/orders-physical', disabled: false, show: false, permission: 'view_orders_physical' },
                    { title: this.$t('Cotizaciones'), path: '/admin/quotes', disabled: false, show: false, permission: 'view_quotes' },
                ],
            },
            {
                header: false,
                role: 'store',
                icon: 'cash',
                title: this.$t('Gastos'),
                path: '/admin/expenses',
                show: false,
                permission: 'view_expenses'
            },
            {
                header: false,
                role: 'store',
                icon: 'cube',
                title: this.$t('Productos/Servicios'),
                subItems: [
                    { title: this.$t('Nuevo producto'), path: '/admin/new-product', disabled: false, show: false, permission: 'create_products' },
                    { title: this.$t('Nuevo servicio'), path: '/admin/new-service', disabled: false, show: false, permission: 'create_services' },
                    { title: this.$t('Listar productos/servicios'), path: '/admin/products', disabled: false, show: false, permission: 'view_products' },
                    { title: this.$t('Categorías'), path: '/admin/categories', disabled: false, show: false, permission: 'view_categories' },
                    { title: this.$t('Complementos'), path: '/admin/complements', disabled: false, show: false, permission: 'view_complements' },
                ],
                show: false
            },
            {
                header: false,
                role: 'store',
                icon: 'table-large',
                title: this.$t('Inventario'),
                path: '/admin/inventory',
                show: false,
                permission: 'view_inventory'
            },
            {
                header: false,
                role: 'store',
                icon: 'phone-classic',
                title: this.$t('Whatsapp IA'),
                subItems: [
                    // { title: this.$t('Contactos'), path: '/admin/instances/contacts', disabled: false, show: false, permission: 'view_marketing' },
                    // { title: this.$t('Lista de contactos'), path: '/admin/instances/contact-lists', disabled: false, show: false, permission: 'view_marketing' },
                    { title: this.$t('Dar órdenes'), path: '/admin/instances/ia', disabled: false, show: false, permission: 'view_marketing' },
                    { title: this.$t('Archivos'), path: '/admin/instances/files', disabled: false, show: false, permission: 'view_marketing' },
                    // { title: this.$t('Instancia'), path: '/admin/instances/instance', disabled: false, show: false, permission: 'view_marketing' },
                    { title: this.$t('Campañas'), path: '/admin/instances/campaigns', disabled: false, show: false, permission: 'view_marketing' },
                    // { title: this.$t('Envío masivo'), path: '/admin/instances/campaign-plans', disabled: false, show: false, permission: 'view_marketing' },
                ],
                show: false,
            },
            /* {
                header: false,
                role: 'store',
                icon: 'account-multiple',
                title: this.$t('Clientes'),
                path: '/admin/clients',
                show: false,
                permission: 'view_clients'
            }, */
            {
                header: false,
                role: 'store',
                icon: 'account-multiple',
                title: this.$t('Clientes'),
                subItems: [
                    { title: this.$t('Listar clientes'), path: '/admin/clients', disabled: false, show: false, permission: 'view_clients' },
                    { title: this.$t('Categorías de clientes'), path: '/admin/instances/contact-lists', disabled: false, show: false, permission: 'view_marketing' },
                ],
                show: false,
            },
            {
                header: false,
                role: 'store',
                icon: 'chart-bar',
                title: this.$t('Estadísticas'),
                subItems: [
                    { title: this.$t('General'), path: '/admin/dashboard', disabled: false, show: false, permission: 'view_statistics' },
                ],
                show: false
            },
            {
                header: false,
                role: 'store',
                icon: 'ticket-percent',
                title: this.$t('Cupones y descuentos'),
                path: '/admin/coupons',
                show: false,
                permission: 'view_coupons'
            },
            {
                header: false,
                role: 'store',
                icon: 'alert-octagon',
                title: this.$t('Avisos'),
                path: '/admin/alerts',
                show: false,
                permission: 'view_notices'
            },
            {
                header: false,
                role: 'store',
                icon: 'archive-clock-outline',
                title: this.$t('Horarios'),
                path: '/admin/schedule',
                show: false,
                permission: 'view_schedules'
            },
            {
                header: false,
                role: 'store',
                icon: 'application-outline',
                title: this.$t('Páginas'),
                subItems: [
                    { title: this.$t('Nuevo registro'), path: '/admin/new-page', disabled: false, show: false, permission: 'create_pages' },
                    { title: this.$t('Listar páginas'), path: '/admin/pages', disabled: false, show: false, permission: 'view_pages' }
                ],
                show: false
            },
            {
                header: false,
                role: 'store',
                icon: 'cogs',
                title: this.$t('Configuración'),
                subItems: [
                    { title: this.$t('Mi negocio'), path: '/admin/my-store', disabled: false, show: false, permission: 'view_settings_store' },
                    { title: this.$t('Datos del pedido'), path: '/admin/my-orders', disabled: false, show: false, permission: 'view_settings_orders' },
                    { title: this.$t('Roles de la tienda'), path: '/admin/my-roles', disabled: false, show: false, permission: 'view_roles' },
                    { title: this.$t('Usuarios de la tienda'), path: '/admin/my-users', disabled: false, show: false, permission: 'view_users' },
                    { title: this.$t('Pantallas'), path: '/admin/screens', disabled: false, show: false, permission: 'view_users' }
                ],
                show: false
            },
            {
                header: false,
                role: 'store',
                icon: 'cart',
                title: this.$t('Reservas'),
                path: '/admin/reservations',
                show: false,
                permission: 'view_reservations'
            },
            {
                header: false,
                role: 'store',
                icon: 'home-city',
                title: this.$t('Agendamiento'),
                path: '/admin/real_states',
                show: false,
                permission: 'view_real_states'
            },
            {
                header: false,
                role: 'store',
                icon: 'cash-register',
                title: this.$t('Pedidos, puntos de venta'),
                path: '/admin/cash-register',
                show: false,
                permission: 'view_points'
            },
            {
                header: false,
                role: 'store',
                icon: 'cash-register',
                title: this.$t('Preventas'),
                path: '/admin/presales',
                show: false,
                permission: 'view_presals'
            },
            // editor
            {
                header: false,
                role: 'editor',
                icon: 'view-dashboard',
                title: this.$t('Mi panel'),
                path: '/admin/dashboard',
                show: true
            },
            {
                header: false,
                role: 'editor',
                icon: 'store',
                title: this.$t('Negocios'),
                subItems: [
                    { title: this.$t('Listar negocios'), path: '/admin/stores', disabled: false, show:true },
                ],
                show: true
            },
            {
                header: false,
                role: 'editor',
                icon: 'domain',
                title: this.$t('Tiendas matriz'),
                subItems: [
                    { title: this.$t('Listar Tiendas'), path: '/admin/parent-stores', disabled: false, show:true },
                ],
                show: true
            },
        ]
        this.path = window.location.pathname;
        this.findActivePath()
        if (this.userRole == 'store') {
            this.getAllNotify()
            setTimeout(() => {
                this.getVisibleItems()
            }, 600);
        } else {
            this.showDrawer = true
        }
        this.getEmergency()
    },
    mounted() {
        // "Desbloquear" reproducción de sonido
        const unlockAudio = () => {
            const unlock = new Audio();
            unlock.volume = 0;
            unlock.play().then(() => {
                unlock.remove();
            }).catch(() => {});
            document.body.removeEventListener('click', unlockAudio);
        };

        document.body.addEventListener('click', unlockAudio);

        window.Echo.channel('digital-sale')
        .listen('.digital.sale', (e) => {
            if (e.data && e.data[0] === this.slug) {
                this.getAllNotify()
                this.playNotificationSound();
                this.dialogSale = true;
            }

        });

        if (localStorage.getItem('changeBranch')) {
            this.$fire({
                title: this.$t('Cambio de sucursal exitoso.'),
                text: this.$t('El cambio de sucursal se ha realizado con exito.'),
                type: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
            })
            localStorage.removeItem('changeBranch')
        }

        this.setSelect();
    },
    methods: {
        playNotificationSound(times = 3) {
            if (times <= 0) return;
            const sound = new Audio('/sounds/notification.mp3');
            sound.preload = 'auto';
            sound.volume = 0.8;
            sound.play().catch(e => {
                console.warn('Reproducción de sonido bloqueada (usuario no interactuó)', e);
            });
            sound.addEventListener('ended', () => {
                this.playNotificationSound(times - 1);
            });
        },
        goToDigitalSales() {
            this.dialogSale = false;
            window.location.href = '/admin/orders';
        },
        // notifications
        async getAllNotify() {
            await axios.get(`/admin/cant-orders/${this.slug}`)
            .then((response) => {
                // console.log(response)
                this.cantOrder = response.data[0]
                this.cantOrder2 = response.data[1]
                this.cantOrder3 = response.data[2]
                this.items[16].show = response.data[3]>0 ? true : false //"Reservas"
                // this.items[17].show = this.typeStore=='real_estate' ? true : false //"Agendamiento"
                this.cantOrder4 = response.data[4]

                if (response.data[5]) {
                    this.$store.dispatch('numberDecimals/setNumberDecimals', response.data[5])
                }
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
        // end notifications
        // menu de puntos de venta y preventas
        async getVisibleItems() {
            if (this.typeStore !== 'real_estate') {
                await axios.get(`/admin/visible-items/?slug=${this.slug}`)
                .then((response) => {
                    // console.log(response);

                    if (response.data.sales>0) {
                        this.items[18].show = true //"Pedidos, puntos de venta"
                    }
                    if (response.data.presales>0) {
                        this.items[19].show = true //"Preventas"
                    }
                    // console.log(this.items);

                    this.physicalStore = response.data.physical ? true : false
                    this.hasQuotes = response.data.hasQuotes ? true : false
                    if (this.physicalStore) {
                        this.items[10].subItems.push({ title: this.$t('Análisis'), path: '/admin/physical-store', disabled: false, show: false, permission: 'view_statistics_analytics' }) //"Estadísticas"
                    }
                    this.items[10].subItems.push({ title: this.$t('Retorno'), path: '/admin/returns', disabled: false, show: false, permission: 'view_statistics_returns' }) //"Estadísticas"

                    this.items[10].subItems.push({ title: this.$t('Historial de cajas'), path: '/admin/history-cashier', disabled: false, show: false, permission: 'view_history_cashier' }) //"Estadísticas"

                    // show menu
                    const permissions = response.data.permission
                    let itemShow = false
                    this.items.forEach((item, index) => {
                        if (item.role == 'store') {
                            if (item.subItems) {
                                itemShow = false
                                item.subItems.forEach(sub => {
                                    if (permissions.includes(sub.permission)) {
                                        sub.show = true
                                        itemShow = true
                                    } else {
                                        sub.show = false
                                    }
                                });
                                // verificar la cantidad de true
                                if (itemShow) item.show = true
                            } else {
                                if (permissions.includes(item.permission)) {
                                    item.show = true
                                } else {
                                    item.show = false
                                }

                                // if (item.permission == 'view_real_states') {
                                //     item.show = this.typeStore == 'real_estate' ? true : false
                                // }
                            }
                        } else {
                            item.show = true
                        }
                    });
                    // Mostrar "Pantallas" solo si typeStore es 'gastronomic'
                    const configItem = this.items.find(item => item.title === this.$t('Configuración'));
                    if (configItem && configItem.subItems) {
                        configItem.subItems = configItem.subItems.map(subItem => {
                            if (subItem.title === this.$t('Pantallas')) {
                                return {
                                    ...subItem,
                                    show: this.typeStore === 'gastronomic'
                                };
                            }
                            return subItem;
                        });
                    }

                    if (permissions.includes('new_sale')) {
                        this.showBtnNewSales = true
                    }
                    if (permissions.includes('new_expense')) {
                        this.showBtnNewExpense = true
                    }

                    // verificar si tiene permisos de ver inventario
                    if (response.data.inventory) {
                        this.items[7].show = true //"Inventario"
                    }else {
                        this.items[7].show = false //"Inventario"
                    }

                    // verificar si tiene hasMarketing: view_marketing
                    if (!response.data.hasMarketing) {
                        this.items[8].show = false;
                        this.items = this.items.map((it) => {
                            if(it.subItems) {
                                it.subItems = it.subItems.map((si) => {
                                    if(si.permission === "view_marketing") {
                                        si.show = false;
                                    }
                                    return si;
                                });
                            } else {
                                if(it.permission === "view_marketing") {
                                    it.show = false;
                                }
                            }
                            return it;
                        });
                    }

                    this.banner = response.data.banner
                    this.logo = response.data.logo

                    if (response.data.restaurant) {
                        this.physicalRestaurant = true
                        this.physicalRestaurantUrl = response.data.link_restaurant
                    }

                    if (response.data.cash) {
                        this.typeCash = 'open'
                        this.dialogCash = true
                    }
                    this.btnCloseCash = response.data.cash_btn?0:1

                    // sucursales
                    this.branches = response.data.branches

                    this.findActivePath()

                    setTimeout(() => {
                        this.showDrawer = true
                    }, 300);
                })
                .catch((error) => {
                    console.log(error);
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$notify.error(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                    }
                })
            }
            else {
                const tempItems = [
                    {
                        header: false,
                        role: 'store',
                        icon: 'home-city',
                        title: this.$t('Agendamiento'),
                        path: '/admin/real_states',
                        show: true,
                        permission: 'view_real_states'
                    },
                    {
                        header: false,
                        role: 'store',
                        icon: 'cube',
                        title: this.$t('Inmuebles'),
                        subItems: [
                            { title: this.$t('Nuevo inmueble'), path: '/admin/new-product', disabled: false, show: true, permission: 'create_products' },
                            { title: this.$t('Listar inmuebles'), path: '/admin/products', disabled: false, show: true, permission: 'view_products' },
                            { title: this.$t('Categorías'), path: '/admin/categories', disabled: false, show: true, permission: 'view_categories' },
                        ],
                        show: true
                    },
                    {
                        header: false,
                        role: 'store',
                        icon: 'account-multiple',
                        title: this.$t('Clientes'),
                        subItems: [
                            { title: this.$t('Listar clientes'), path: '/admin/clients', disabled: false, show: true, permission: 'view_clients' },
                            // { title: this.$t('Categorías de clientes'), path: '/admin/instances/contact-lists', disabled: false, show: true, permission: 'view_marketing' },
                        ],
                        show: true,
                    },
                    {
                        header: false,
                        role: 'store',
                        icon: 'alert-octagon',
                        title: this.$t('Avisos'),
                        path: '/admin/alerts',
                        show: true,
                        permission: 'view_notices'
                    },
                    {
                        header: false,
                        role: 'store',
                        icon: 'application-outline',
                        title: this.$t('Páginas'),
                        subItems: [
                            { title: this.$t('Nuevo registro'), path: '/admin/new-page', disabled: false, show: true, permission: 'create_pages' },
                            { title: this.$t('Listar páginas'), path: '/admin/pages', disabled: false, show: true, permission: 'view_pages' }
                        ],
                        show: true
                    },
                    {
                        header: false,
                        role: 'store',
                        icon: 'cogs',
                        title: this.$t('Configuración'),
                        subItems: [
                            { title: this.$t('Mi negocio'), path: '/admin/my-store', disabled: false, show: true, permission: 'view_settings_store' },
                            { title: this.$t('Datos del pedido'), path: '/admin/my-orders', disabled: false, show: true, permission: 'view_settings_orders' },
                            { title: this.$t('Roles de la tienda'), path: '/admin/my-roles', disabled: false, show: true, permission: 'view_roles' },
                            { title: this.$t('Usuarios de la tienda'), path: '/admin/my-users', disabled: false, show: true, permission: 'view_users' }
                        ],
                        show: true
                    },
                ]
                this.items = tempItems
                setTimeout(() => {
                    this.showDrawer = true
                }, 300);
            }
        },
        findActivePath () {
            this.items.forEach(element => {
                if (!element.header && element.subItems) {
                    for (let i = 0; i < element.subItems.length; i++) {
                        if (element.subItems[i].path === this.path) {
                            element.active = true
                            break
                        }
                    }
                }
            });
        },
        async logout () {
            await axios.post(`/logout`)
            .then((response) => {
                if (response.status === 204) {
                    localStorage.clear();
                    location.reload();
                }
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
         /**
          * emergency
          */
        async getEmergency() {
            await axios.post('/admin/get-emergency')
            .then((response) => {
                // console.log(response)
                this.ifEmergency = (response.data)?true:false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
        async changeEmergency() {
            await axios.post('/admin/change-emergency')
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$alert('', (this.ifEmergency) ? this.$t('Tienda abierta.') : this.$t('Tienda cerrado.'), 'success', {confirmButtonText: this.$t('Continuar')})
                    this.ifEmergency = !this.ifEmergency
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
        async setSelect() {
            setTimeout(async () => {
                let items = await this.getSuscrs();
                items = items.map(it => {
                    return (it.value === 'TECNOLOGIA') ? {...it, selected: true} : it;
                });
                if(items.length > 0) {
                    $('#switch-app').ddslick({
                        data: items,
                        width: '100%',
                        onSelected: (data) => {
                            console.log(`Data: ${data.selectedData.value}`);
                            if(data.selectedData.value !== 'TECNOLOGIA') {
                                this.changeApp(data.selectedData.value);
                            }
                        }
                    });
                    //$('#switch-app').ddslick('select', {value: 'TECNOLOGIA' });
                } else {
                    document.querySelector("#switch-container").style.backgroundColor = "#3c3c3c";
                }
            }, 3000);
        },
        async changeApp(app) {
            let items = await this.getSuscrs();
            let sel_app = items.find(it => it.value === app);
            let app_user_id = sel_app.usuario_id_app;

            switch (app) {
                case 'GESTION':
                    window.location.href = `https://erp.quick.com.bo/one/${app_user_id}/2jfqs6xkn7hqm7mxppgdjngqe8h0zx`;
                    break;
                case 'TECNOLOGIA':
                    window.location.href = `https://cat.quick.com.bo/one/${app_user_id}/2jfqs6xkn7hqm7mxppgdjngqe8h0zx`;
                    break;
                case 'VENTAS':
                    window.location.href = `https://crm.quick.com.bo/one/${app_user_id}/2jfqs6xkn7hqm7mxppgdjngqe8h0zx`;
                    break;
                case 'FACTURACION':
                    window.location.href = `https://fac.quick.com.bo/one/${app_user_id}/2jfqs6xkn7hqm7mxppgdjngqe8h0zx`;
                    break;
                case 'RESTAURANTE_FISICO':
                    window.location.href = `https://cat.quick.com.bo/one/${app_user_id}/2jfqs6xkn7hqm7mxppgdjngqe8h0zx?res=true`;
                    break;
                default: break;
            }
        },
        async getSuscrs() {
            try {
                let res = await axios.get('/user-suscrs', {
                    withCredentials: true,
                    headers: { Accept : "application/json" }
                });
                return res.data;
            } catch (error) { console.log(error); }
            return [];
        },
        async changeBranch(branch) {
            this.overlay = true;
            await axios.post('/admin/change-branch', {branch: branch})
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    localStorage.setItem('changeBranch', true);
                    location.reload();
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.overlay = false;
            })
        },
        showTutoriales() {
            try {
                let info = {
                    platform: "cat",
                    user_id: parseInt(this.userId)
                };
                let info_encoded = btoa(JSON.stringify(info));
                window.open(
                    `https://one.quick.com.bo/tutorials?info=${info_encoded}`,
                    'tutorials',
                    'width=800,height=400,menubar=no,toolbar=no,location=no,status=no,scrollbars=no,resizable=no'
                );
            } catch (error) { console.log(error); }
        }
    },
    computed: {
        numberDecimals () {
            return this.$store.state.numberDecimals.numberDecimals
        }
    },
}
</script>
<style lang="scss">
    .v-list-item.active {
        &::before {
            opacity: 0.2;
        }
    }

    #switch-app {
        margin: 0 auto;
    }
    .dd-selected {
        border-radius: 0.5em !important;
        border: none !important;
        color: black;
    }
    .dd-select {
        background-color: white !important;
        border: solid 0px #ccc;
    }
    .dd-option-image, .dd-selected-image {
        max-width: 20px !important;
        margin-right: 1em;
    }
    .dd-selected-text, .dd-option-text {
        line-height: 20px !important;
    }
    .dd-options {
        padding-left: 0px !important;
    }
</style>
